import EvidendeIndicator from "../../evidence/EvidenceIndicator";
import GhostInfoSection from "../GhostInfoSection";
import SpeedIndicator, { speedExactly } from "../SpeedIndicator";

export default function Wraith() {
    return (
        <div>
            <div>A Wraith can fly and walk through walls.</div>
            <div className="ghost-details">
                <GhostInfoSection title="Evidence">
                    <ul className="list-unstyled">
                        <li><EvidendeIndicator evidenceType="EMF 5" /></li>
                        <li><EvidendeIndicator evidenceType="Spirit Box" /></li>
                        <li><EvidendeIndicator evidenceType="D.O.T.S." /></li>
                    </ul>
                </GhostInfoSection>
                <GhostInfoSection title="Behavior">
                    <ul>
                        <li>It can float above the ground, without disturbing salt or leaving UV evidence. But it still makes footstep sounds.</li>
                        <li>It can teleport to a different location, without triggering sensors.</li>
                    </ul>
                </GhostInfoSection>
                <GhostInfoSection title="Special Ability">
                    When using its ability while not hunting, a Wraith will teleport to a random player, 
                    generating EMF 2 or even EMF 5.
                </GhostInfoSection>
            </div>
        </div>
    );
}

export function WraithSpeedIndicator() {
    return <SpeedIndicator speed={speedExactly(1.7)} />
}